/**
 * <ReadOnlyField> — une valeur déjà connue, montrée à la place de son champ (molecule).
 *
 * Quand une étape précédente a déjà recueilli une information (l'adresse e-mail, avant le mot de
 * passe), on la MONTRE au lieu de la redemander : le même cadre qu'un champ, son intitulé en petit,
 * la valeur, et à droite « Modifier », qui y ramène. Sans `onEdit`, la valeur est figée.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { TextButton } from "../../atoms/Buttons/TextButton"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { fieldContour } from "../../atoms/TextInput"
import { Text } from "../../atoms/typography/Text"

export type ReadOnlyFieldProps = {
    /** Ce que la valeur est — « Adresse e-mail ». */
    label: string
    value: string
    /** « Modifier » : ramène à l'étape qui a recueilli la valeur. Absent → la valeur est figée. */
    onEdit?: () => void
    testID?: string
}

export function ReadOnlyField(props: ReadOnlyFieldProps) {
    const { label, value, onEdit, testID } = props

    return (
        <Row
            testID={testID}
            align="center"
            justify="between"
            gap="2"
            style={[fieldContour.frame("border", "surface-subtle", false), styles.field]}
        >
            <Stack gap="0" style={styles.text}>
                <Text size="text-sm" color="text-muted">
                    {label}
                </Text>
                <Text color="text-strong">{value}</Text>
            </Stack>
            {onEdit != null && <TextButton label="Modifier" onPress={onEdit} />}
        </Row>
    )
}

const styles = StyleSheet.create((theme) => ({
    field: {
        paddingHorizontal: theme.spacing["3"],
        paddingVertical: theme.spacing["2"],
    },
    // Une adresse longue passe à la ligne ; elle ne pousse jamais le geste hors du cadre.
    text: {
        flex: 1,
    },
}))
